const cancelcircle = {
  name: 'cancel-circle',
  viewBox: '0 0 32 32',
  paths: [
    {
      d: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM21 8l-5 5-5-5-3 3 5 5-5 5 3 3 5-5 5 5 3-3-5-5 5-5z'
    }
  ]
};

export default cancelcircle;
